import { useEffect, useState } from 'react';

/** 이 모임에 붙은 활성 안전귀가 세션.
 *
 * 상세 화면과 측위 화면이 같은 조회를 각자 복사해 쓰고 있었습니다.
 * 한쪽은 목록을, 다른 쪽은 "있는지 여부"만 필요해 달라 보였을 뿐입니다.
 * repository 는 동적 import 로 가져옵니다 — 안전귀가를 안 쓰는 화면까지
 * 번들에 끌려오지 않게 하려던 기존 방식을 그대로 뒀습니다.
 */
export function useSafeReturnSessions(meetingId?: string | null, reloadKey?: unknown): any[] {
    const [sessions, setSessions] = useState<any[]>([]);

    useEffect(() => {
        if (!meetingId) return;
        let cancelled = false;
        import('repository/safeReturnRepository').then(({ SafeReturnRepository }) => {
            SafeReturnRepository.onGetActiveSessionsByMeeting(meetingId)
                .then((res: any) => {
                    if (cancelled) return;
                    const list = res?.data?.data || res?.data || [];
                    setSessions(Array.isArray(list) ? list : []);
                })
                .catch(() => { if (!cancelled) setSessions([]); });
        });
        return () => { cancelled = true; };
    }, [meetingId, reloadKey]);

    return sessions;
}
